import { Box, Chip, Stack, useTheme } from '@mui/material';
import {
  AllCapsSubheader,
  GreyText,
  NoneFoundText,
  SubHeader,
} from 'features/Principal/PrincipalCandidatesList/styles';
import { degreeSubjects, universities } from 'utils/enums';
import { BasicInfoBox, Subtitle } from '../../../styles';
import { getDegreeText } from './utils';
import { ATSPrincipalAppCandidateModalTabsTestIds } from 'data-testids/ATS';
import { EducationItemProps, EducationProps } from 'features/Principal/types/modalTypes';

export const IndividualEducationItem: React.FC<EducationItemProps> = ({ item }) => {
  const theme = useTheme();

  const getSchoolName = () => {
    const school = universities().find((u) => u.value === parseInt(String(item.university), 10));
    return school && school.label;
  };

  const getMajor = () => {
    const major = degreeSubjects().find((u) => u.value === parseInt(String(item.major_enum), 10));
    return major && major.label;
  };

  const degree = getDegreeText(String(item.degree));

  return (
    <BasicInfoBox data-testid={ATSPrincipalAppCandidateModalTabsTestIds.INDIVIDUAL_EDUCATION_ITEM}>
      <Stack direction="row" justifyContent="space-between">
        <Subtitle>{getSchoolName()}</Subtitle>
        <Chip sx={{ backgroundColor: theme.palette.white.darker }} label={degree} />
      </Stack>
      <GreyText>{getMajor()}</GreyText>
      <Stack direction="row">
        {item.start_date && (
          <GreyText>
            {new Date(item.start_date).toLocaleDateString('default', {
              month: 'long',
              year: 'numeric',
            })}
            &nbsp;
          </GreyText>
        )}
        {item.start_date && item.end_date && <GreyText>-&nbsp;</GreyText>}
        {item.end_date && (
          <GreyText>
            {new Date(item.end_date).toLocaleDateString('default', {
              month: 'long',
              year: 'numeric',
            })}
          </GreyText>
        )}
      </Stack>
    </BasicInfoBox>
  );
};

export const Education: React.FC<EducationProps> = ({ educationItems }) => {
  return (
    <Box sx={{ pt: 2 }} data-testid={ATSPrincipalAppCandidateModalTabsTestIds.EDUCATION_SECTION}>
      <SubHeader variant="h3" sx={{ mb: 1 }}>
        Education History
      </SubHeader>
      <AllCapsSubheader>Degrees</AllCapsSubheader>
      {educationItems.length == 0 && <NoneFoundText>No degrees found</NoneFoundText>}
      {educationItems.map((experience) => (
        <IndividualEducationItem key={experience.id} item={experience} />
      ))}
    </Box>
  );
};
